module.exports = __webpack_public_path__ + "static/img/Business-Intelligence-BI-1.b40b71d6.jpg";